import React from 'react';
import { withRouter } from 'react-router';
import { SubscriptionPage } from './index';
import { hasAccountActiveSubscription } from '../../../utils';

const SubscriptionManager = ({ history }) => {
  const accountHasActiveSubscription = hasAccountActiveSubscription();
  if (accountHasActiveSubscription) {
    history.push('/');
  }
  return <SubscriptionPage/>;
};

export default withRouter(SubscriptionManager);
